<template>
  <div>
    <h1 class="title">Purchase items (ID: {{ $route.params.id }})</h1>
  </div>
</template>

<script>
export default {
  name: 'PurchaseItemsDetail',
  created() {
    document.title = `Purchase items (ID: ${ this.$route.params.id }) | Altezza Board`
  }
}
</script>
